import { Component, OnInit, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../user.service';
import { isPlatformBrowser } from '@angular/common';
import { NotifierService } from 'angular-notifier';
import { NavbarService } from './navbar.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  isLoggedIn: boolean = false;
  isScrolled = false;
  isHidden = false;   // 👉 ajout pour cacher/montrer
  lastScrollTop = 0;  // 👉 dernière position du scroll
  scrollTimeout: any; // 👉 timer pour “arrêt du scroll”

  private readonly notifier: NotifierService;
  public data: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private userService: UserService,
    notifierService: NotifierService,
    public router: Router,
    private navbar: NavbarService
  ) {
    this.notifier = notifierService;
    this.navbar.getData().subscribe((data: any) => {
      this.data = data.data;
    });
  }

  ngOnInit(): void {
    this.userService.isLoggedIn$.subscribe((status) => {
      this.isLoggedIn = status;
    });
  }

  // 👉 gestion du scroll
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (isPlatformBrowser(this.platformId)) {
      const st = window.scrollY || document.documentElement.scrollTop;

      // ajoute une classe scrolled pour l’effet visuel
      this.isScrolled = st > 10;

      // si on descend → cacher
      if (st > this.lastScrollTop) {
        this.isHidden = true;
      } else {
        // si on monte → montrer
        this.isHidden = false;
      }

      this.lastScrollTop = st <= 0 ? 0 : st;

      // 👉 quand on arrête de scroller → réaffiche après 200ms
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.isHidden = false;
      }, 200);
    }
  }

  classApplied = false;
  toggleClass() {
    this.classApplied = !this.classApplied;
  }

  searchClassApplied = false;
  searchToggleClass() {
    this.searchClassApplied = !this.searchClassApplied;
  }

  logOutUser() {
    this.userService.logOut();
  }

  dropdownOpenMap: { [key: string]: boolean } = {};

  toggleDropdown(menuName: string): void {
    const wasOpen = this.dropdownOpenMap[menuName];

    Object.keys(this.dropdownOpenMap).forEach(key => {
      this.dropdownOpenMap[key] = false;
    });

    if (!wasOpen) {
      this.dropdownOpenMap[menuName] = true;
    }
  }

  getTagFromLink(menuLink: string): string {
    if (!menuLink) return '';
    return menuLink.replace(/^\/+/, '');
  }
}